module.exports = __webpack_public_path__ + "img/qrcode.f25bad09.png";